export const VALID_TALENT_DB_SORT_PARAMS = [
  'talentDb',
  'salary',
  'jobSeekingStatus',
  'jobRole',
  'eligibility',
  'campus',
  'name',
];
